// Logger utility for production-safe logging.
//
// Console-only by design. The runtime environment is responsible for
// scraping browser-error output from stdout / DevTools and aggregating
// it however the platform wants. We deliberately avoid wiring a
// third-party error tracker (Sentry / LogRocket / etc.) into the SPA.

const isDevelopment = process.env.NODE_ENV === "development";

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.log(...args);
    }
  },

  error: (...args) => {
    // Always log errors so the runtime can scrape them from stdout.
    // eslint-disable-next-line no-console
    console.error(...args);
  },

  warn: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.warn(...args);
    }
  },

  info: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.info(...args);
    }
  },

  debug: (...args) => {
    if (isDevelopment) {
      // eslint-disable-next-line no-console
      console.debug(...args);
    }
  },
};

export default logger;
